import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs';
import { ReportsService } from 'src/app/services/reports.service';
import { Location } from '@angular/common'
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-mi-consolidated-count-wise-vendor-report',
  templateUrl: './mi-consolidated-count-wise-vendor-report.component.html',
  styleUrls: ['./mi-consolidated-count-wise-vendor-report.component.scss']
})
export class MiConsolidatedCountWiseVendorReportComponent implements OnInit {
  @Input() finyear: string;
  // @Input() vendorCode: string;
  
  @ViewChild('dataTable') tableContainer: ElementRef;
  miUnderProcessReport: MenuItem[];
  
  public actionType: any;
  // public finYear: any;
  public miTableData: any = [];
  public miTableDataWithFilter: any = [];
  public loading: boolean = false;
  public userId: any;
  public subscriptions: any = [];
  public subjectSub:any;
  public isAdminLogin: boolean = false;
  public underProcessCount: any;
  public showDrillDownTable: boolean = false;

  public miBifurcatedData: any;
  public options1: any;

  public tableHeaderName = 'Application Details';
  public tableHeaderColor = '#FFFFFF';

  public actionTypesFromTableData: any = [];

  public selectedMIUnderProcFilter: any;
  public miUnderProcFilterList: any = [];
  vendorCode:any
  userType:any
  // visible: boolean = false;

  // showDialog() {
  //     this.visible = true;
  // }
  constructor(
    private route: ActivatedRoute,
    private reportsService: ReportsService,
    private router: Router,
    private location: Location,
    private loader: AppLoaderService,
    private messageService: MessageService,
    private cryptoJsService: CryptoJsService
  ) { }
  // items: MenuItem[];
    
  // activeIndex: number = 0;

  ngOnInit(): void {
    // this.items = [
    //   {
    //     label: 'Personal',
    //     routerLink: 'personal',
    //     status: 'success', // Success status for Personal
    //   },
    //   {
    //     label: 'Seat',
    //     routerLink: 'seat',
    //     status: 'pending', // Pending status for Seat
    //   },
    //   {
    //     label: 'Payment',
    //     routerLink: 'payment',
    //     status: 'pending', // Pending status for Payment
    //   },
    // ];
    // this.actionType = this.route.snapshot.paramMap.get('actionType');
    // this.finYear = this.route.snapshot.paramMap.get('finYear');
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    this.vendorCode=JSON.parse(sessionToken).officeCode;

    // this.userIdUpperCase = JSON.parse(payload)?.sub
    this.userType=JSON.parse(sessionToken).role

    // console.log(this.finYear, this.actionType);

    // this.finYear = 'All';
    // if(this.finYear == 'All'){
    //   this.finYear = '';
    // }

    // if(this.actionType == 3){
    //   console.log('action type 3');
    //   this.loadCountBoxesData();
    // }else{
    //   this.loadMIData('3');
    // }

    this.loadCountBoxesData();

    this.miUnderProcessReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.miTableDataWithFilter, `MI_${this.tableHeaderName}`);
        },
      },
      // {
      //   label: 'Download Pdf',
      //   icon: 'pi pi-fw pi-download',
      //   command: () => {
      //     this.downloadSheetAsPdf(
      //       this.appVerificationModel,
      //       'App_Verification_List'
      //     );
      //   },
      // },
    ];
  }

  // getStepClass(step: MenuItem) {
  //   return step.status === 'success' ? 'success' : 'pending';
  // }
  // nextStep() {
  //   if (this.activeIndex < this.items.length - 1) {
  //     this.activeIndex++;
  //   }
  // }
  
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP ID': d.appid,
          'District': d?.District,
          'Block': d?.Block,
          'Village': d?.Village,
          'Current Level': d.Level_ID,
          'Current Action': d.ActionType,
          'Last Action Date': d.assigneddate,
          'Status': d.Status,
          'Pending Level': d.nextuser,
          'Pending Action': d.NextAction,
          'KYC Status': d.KYCStatus,
          'KYC Date': d.TransDate,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  loadCountBoxesData() {
    this.loader.start();

    let sub = this.reportsService
      .getMIAggTabsUnProcessedAppsCountNewVendor(this.vendorCode, this.finyear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.underProcessCount = data[0];
            this.loadMIBifurcatedDataForGraph();
          } else {
            this.underProcessCount = null;
            this.loadMIBifurcatedDataForGraph();
          }
        },
        error: (err) => {
          // this.loading = false;
          this.loader.close();
          this.underProcessCount = null;
          this.loadMIBifurcatedDataForGraph();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });

      this.subscriptions.push(sub);
  }

  loadMIBifurcatedDataForGraph() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.miBifurcatedData = {
      // labels: [`MI(PDMC) Applications: (${miTotalCount}) `, `Pond/Tank Applications: (${pondTotalCount})`],
      labels: ['App Scrutiny/Verification', 
        'Pre-Survey By Vendor', 
        'Vendor Estimate',  
        'Estimate Scrutiny/Verification', 
        'Challan(FS) Generation',
        'Farmer Share Deposited',
        'Installation',
        'Field Inspection',
        'Subsidy Approvals',
        'Subsidy Lots Creation',
        'Subsidy Disbursement',
      ],
      datasets: [
        {
          data: [
            this.underProcessCount?.IncompleteApps, 
            this.underProcessCount?.preestimate, 
            this.underProcessCount?.pendingEstimateApp, 
            this.underProcessCount?.pendingEstApproved, 
            this.underProcessCount?.pending_challan, 
            this.underProcessCount?.pending_challan_deposit, 
            this.underProcessCount?.Pending_BOQ, 
            this.underProcessCount?.pending_PV, 
            this.underProcessCount?.pending_Subsidy, 
            this.underProcessCount?.pending_lot, 
            this.underProcessCount?.pending_subsidy_disbursal
          ],
          backgroundColor: [
            // documentStyle.getPropertyValue('--green-600'),
            // documentStyle.getPropertyValue('--yellow-600'),
            '#00b33c',
            '#8a8a5c',
            '#ff0000',
            '#ff9900',
            '#3939ac',
            '#b30000',
            '#408000',
            '#2952a3',
            '#b30059',
            '#52527a',
            '#e67300'
            // documentStyle.getPropertyValue('--blue-500')
            // documentStyle.getPropertyValue('--pink-500'),
          ],
          hoverBackgroundColor: [
            // documentStyle.getPropertyValue('--green-500'),
            // documentStyle.getPropertyValue('--yellow-500'),
            '#00b33c',
            '#8a8a5c',
            '#ff0000',
            '#ff9900',
            '#3939ac',
            '#b30000',
            '#408000',
            '#2952a3',
            '#b30059',
            '#52527a',
            '#e67300'
            // documentStyle.getPropertyValue('--pink-400'),
          ],
          label: ''
        },
      ],
    };

    this.options1 = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          display: false // Hide the legend
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          type: 'logarithmic', // Use logarithmic scale
          ticks: {
            min: 0, // Set the minimum value
            // stepSize: 2,
            // callback: function(value, index, values) {
            //   if (value === 1) return 0; // Set the first label to 0
            //   const labels = ['500', '1000', '5000', '10000', '50000', '100000']; // Custom labels
            //   return labels[index]; // Return custom labels
            // }
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          // ticks: {
          //   font: {
          //     weight: 700,
          //   },
          //   stepSize: 100,
          //   color: textColorSecondary,
          // },
          grid: {
            display: false,
            // color: this.surfaceBorder,
            // drawBorder: false,
          },
        },
        // y: {
        //   ticks: {
        //     color: textColor,
        //     stepSize: 20,
        //   },
        //   grid: {
        //     color: surfaceBorder,
        //     drawBorder: false
        //   }
        // }

      }
    };

    // this.options1 = {
    //   maintainAspectRatio: false,
    //   aspectRatio: 0.8,
    //   plugins: {
    //     datalabels: {
    //       anchor: 'end',
    //       align: 'end',
    //       color: 'black',
    //       font: {
    //         weight: 'bold'
    //       }
    //     },
    //     legend: {
    //       display: false // Hide the legend
    //     }
    //   },
    //   scales: {
    //     x: {
    //       ticks: {
    //         color: textColor,
    //         font: {
    //           weight: 500
    //         }
    //       },
    //       grid: {
    //         color: surfaceBorder,
    //         drawBorder: false
    //       }
    //     },
    //     y: {
    //       ticks: {
    //         color: textColor
    //       },
    //       grid: {
    //         color: surfaceBorder,
    //         drawBorder: false
    //       }
    //     }

    //   }
    // };
  }

  onMIChartClick(event){
    this.selectedMIUnderProcFilter = null;
    if(event?.element?.index == 0){
      this.onClickCountBox('AppVerification');
      this.tableHeaderName = 'Application Scrutiny/Verification';
      this.tableHeaderColor = '#00b33c';
    }else if(event?.element?.index == 1){
      this.onClickCountBox('PreEstimation');
      this.tableHeaderName = 'Pre-Survey By Vendor';
      this.tableHeaderColor = '#8a8a5c';
    }else if(event?.element?.index == 2){
      this.onClickCountBox('Estimation');
      this.tableHeaderName = 'Vendor Estimate';
      this.tableHeaderColor = '#ff0000';
    }else if(event?.element?.index == 3){
      this.onClickCountBox('EstVerification');
      this.tableHeaderName = 'Estimate Scrutiny/Verification';
      this.tableHeaderColor = '#ff9900';
    }else if(event?.element?.index == 4){
      this.onClickCountBox('Challan');
      this.tableHeaderName = 'Challan(FS) Generation';
      this.tableHeaderColor = '#3939ac';
    }else if(event?.element?.index == 5){
      this.onClickCountBox('ChallanDeposited');
      this.tableHeaderName = 'Farmer Share Deposited';
      this.tableHeaderColor = '#b30000';
    }else if(event?.element?.index == 6){
      this.onClickCountBox('BOQ');
      this.tableHeaderName = 'Installation';
      this.tableHeaderColor = '#408000';
    }else if(event?.element?.index == 7){
      this.onClickCountBox('PVVerification');
      this.tableHeaderName = 'Field Inspection';
      this.tableHeaderColor = '#2952a3';
    }else if(event?.element?.index == 8){
      this.onClickCountBox('Subsidy');
      this.tableHeaderName = 'Subsidy Approvals';
      this.tableHeaderColor = '#b30059';
    }else if(event?.element?.index == 9){
      this.onClickCountBox('subsidy_lot');
      this.tableHeaderName = 'Subsidy Lots Creation'
      this.tableHeaderColor = '#52527a';
    }else if(event?.element?.index == 10){
      this.onClickCountBox('subsidyDis');
      this.tableHeaderName = 'Subsidy Disbursement';
      this.tableHeaderColor = '#e67300';
    }
  }

  // loadMIData(count) {
  //   if(count == 3){
  //     this.loader.start();
  //   }else{
  //     this.loader.close();
  //   }
  //   let sub = this.reportsService
  //     .getConsolidatedAggReportNew2DrillDown(this.finYear, this.actionType, count)
  //     .pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         this.loader.close();
  //         if (data?.length > 0) {
  //           if(count == '1'){
  //             this.miTableData = data;
  //             if(data.length == 100){
  //               this.loadMIData('2');
  //             }
  //           }else if(count == '2'){
  //             this.miTableData = data;
  //             if(data.length == 1000){
  //               this.loadMIData('3');
  //             }
  //           }else if(count == '3'){
  //             this.miTableData = data;
  //           }
  //         } else {
  //           if(count == '1'){
  //             this.miTableData = [];
  //           }
  //         }
  //       },
  //       error: (err) => {
  //         this.loader.close();
  //         if(count == '1'){
  //           this.miTableData = [];
  //         }
  //       },
  //     });

  //     this.subscriptions.push(sub);
  // }

  printForm(appId) {
    
    if (appId) {
      // let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'appliaction-approval', 'print', appId], { queryParams: { statusCode: statusCodeEncrypted } }));
      // window.open(link, '_blank');

      // if(this.subjectSub)
      let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      this.userId = JSON.parse(payload)?.sub;
            // console.log(payload, this.userID);
      if(this.userId == 'admin'){
        this.router.navigate(['admin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['admin', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else if(this.userId == 'CAO'){
        this.router.navigate(['cao', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['cao', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else if(this.userId == 'DD-EW'){
        this.router.navigate(['ew-department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['ew-department', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else if(this.userId== 'Vendor'){
        this.router.navigate(['vendor', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else if(this.userId== 'webadmin'){
        this.router.navigate(['webadmin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else {
        this.router.navigate(['department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }
    }
    else{
      // this.messageService.add({
      //   summary: 'Error Message',
      //   severity: 'info',
      //   detail: 'Application Id Not Found',
      // });
    }
  }

  ngOnDestroy() {
    this.loader.close();
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  onClickBack(){
    this.location.back();
  }
  // onSelect(type:any){
  //   this.loadMIData(type)
  // }

  onClickCountBox(val){
    this.showDrillDownTable = true;
    this.miTableData = [];
    this.miTableDataWithFilter = [];
    this.ngOnDestroy();
    this.loadMIDataUnderProcess(val, 0);
    setTimeout( () => this.tableContainer.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400)
  }

  loadMIDataUnderProcess(subActionType, autoId) {
    // this.loader.start();
    if (autoId == 0) {
      this.loading = true;
    }
    let sub = this.reportsService
      .getMIAggTabsUnProcessedAppsDrillDownNewVendor(this.finyear, subActionType,this.vendorCode,this.userType,autoId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (data?.length > 0) {
            this.miTableData = data;
            this.miTableDataWithFilter = data;

            // Using the function to get unique actionTypes
            this.actionTypesFromTableData, this.miUnderProcFilterList = this.getUniqueActionType(data);

          }else{
            this.miTableData = [];
            this.miTableDataWithFilter = [];
            this.actionTypesFromTableData = [];
          }
        },
        error: (err) => {
          // this.loading = false;
          this.loading = false;
          this.miTableData = [];
          this.miTableDataWithFilter = [];
          this.actionTypesFromTableData = [];
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });

      this.subscriptions.push(sub);
  }

  // getUniqueActionType(data) {
  //   const districts = data.map(entry => entry?.nextuser);
  //   return [...new Set(districts)];
  // }
  getUniqueActionType(data) {
    const actionLevelSet = new Set(data.map(entry => entry.nextuser));
    const actionLevelObjects = Array.from(actionLevelSet).map(actionLevel => ({ actionLevel }));
    
    return actionLevelObjects;
  }

  onSelectMIConsFilter(){
    if(this.selectedMIUnderProcFilter != null){
      this.miTableDataWithFilter = this.miTableData.filter(item => item.nextuser === this.selectedMIUnderProcFilter?.actionLevel);
    }else{
      this.miTableDataWithFilter = this.miTableData;
    }
  }
  
}

